/* Priva shop page — accessory & parts steppers.

   The shop page has three browse grids: Devices, Accessories, Parts.
   - Device cards are plain links to their product pages (PDP). The PDP
     hosts the device configurator (see product-configurator.js).
   - Accessory and parts cards have +/− steppers that add directly to the
     Shopify cart via /cart/add.js and keep the live cart bar in sync
     through window.Priva.
*/

(function () {
  if (!document.querySelector('[data-accessory]')) return;

  // theme.js loads after this script; window.Priva may not exist yet.
  function waitForPriva(retriesLeft) {
    if (window.Priva && typeof window.Priva.fetchCart === 'function') {
      init();
    } else if (retriesLeft > 0) {
      setTimeout(function () { waitForPriva(retriesLeft - 1); }, 30);
    } else {
      console.warn('window.Priva not available — theme.js failed to load');
    }
  }
  waitForPriva(40); // ~1.2s of polling at 30ms intervals

  function init() {
    function changeCartLine(variantId, newQty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: newQty })
      }).then(function (r) { return r.json(); });
    }

    function addToCart(variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      }).then(function (r) { return r.json(); });
    }

    // ----- Standalone accessory/parts grids — direct add to cart -----
    document.querySelectorAll('[data-accessory]').forEach(function (card) {
      var variantId = parseInt(card.dataset.variantId, 10);
      card.querySelectorAll('[data-add-delta]').forEach(function (btn) {
        btn.addEventListener('click', async function (e) {
          e.preventDefault();
          e.stopPropagation();
          var delta = parseInt(btn.dataset.addDelta, 10);
          var display = card.querySelector('[data-qty-display]');
          var currentQty = parseInt(display.textContent, 10) || 0;
          var nextQty = Math.max(0, currentQty + delta);
          if (nextQty === currentQty) return;

          card.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          try {
            if (currentQty === 0 && nextQty > 0) {
              await addToCart(variantId, nextQty);
            } else {
              await changeCartLine(variantId, nextQty);
            }
            var cart = await window.Priva.fetchCart();
            window.Priva.renderCart(cart);
          } catch (err) {
            console.error('Cart update failed', err);
            alert('Sorry, could not update cart. Please try again.');
          } finally {
            card.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
          }
        });
      });
    });
  } // end init
})();
